import {
  type FC
} from 'react';
import {
  Link
} from 'react-router-dom';
import {
  useTheme,
  useMediaQuery
} from '@mui/material';
import {
  Box,
  styled,
} from '@mui/system';
import {
  SwiperSlide,
  Swiper as SwiperReact
} from 'swiper/react';
import {
  Pagination
} from 'swiper/modules';
import 'swiper/css/pagination';
import 'swiper/css';
import {
  SimpleCarouselSliderItem
} from '@shared/types';

export const StyledSwiper = styled(SwiperReact)(({ theme }) => ({
  width: '100%',
  height: 200,

  [theme.breakpoints.up(768)]: {
    marginTop: 32,
  },

  [theme.breakpoints.down(491)]: {
    height: 250
  },
  [theme.breakpoints.down(440)]: {
    height: 220,
    maxWidth: 'none',
  },
  '.swiper-pagination-bullets': {
    bottom: 0,
  },

  '.swiper-pagination-bullet': {
    backgroundColor: theme.palette.common.white,
    position: 'relative',
    width: 6,
    height: 6,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    ':before': {
      content: '""',
      position: 'absolute',
      width: 15,
      height: 20,
    }
  },

  '.swiper-pagination-bullet-active': {
    backgroundColor: theme.palette.common.white,
    width: 22,
    borderRadius: 8,
    transition: 'width 0.1s',
  },
}));

const StyledSwiperSlide = styled(SwiperSlide)(({ theme }) => ({
  maxWidth: 478,
  width: '100%',
  height: 172,
  borderRadius: 8,
  overflow: 'hidden',
  [theme.breakpoints.down(491)]: {
    height: 230,
    maxWidth: 'none',
  },
  [theme.breakpoints.down(440)]: {
    height: 200,
    maxWidth: 'none',
  },
}));

export type PromotionsCarouselProps = {
  items: Array<SimpleCarouselSliderItem>
};

export const PromotionsCarousel: FC<PromotionsCarouselProps> = ({ items }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(491));

  return (
    <StyledSwiper
      spaceBetween={16}
      slidesPerView='auto'
      modules={[Pagination]}
      pagination={{ clickable: true }}>
      {items?.map((item) => (
        <StyledSwiperSlide key={item.id}>
          <Box
            height='100%'
            to={item.bannerUrl}
            component={item.bannerUrl ? Link : 'div'}>
            <Box
              width='100%'
              height='100%'
              component='img'
              borderRadius={8}
              src={isMobile ? item.variant1ImgSrc : item.variant2ImgSrc}
            />
          </Box>
        </StyledSwiperSlide>
      ))}
    </StyledSwiper>
  );
};
